import React from "react"
import { Flex } from "@capioweb/ui-components/src"
import { ContentAreaProperty } from "../../@types/CapioWeb/core"
import { PageBaseProps } from "../../components/Core/pageBase"
import { BlockResolver } from "../../components"
import { EpiContext } from "../../context"
import { shouldRender } from "../../utils"
import { useLocation } from "react-router-dom"
import { HEADER_HEIGHT_S, scale } from "@capioweb/ui-components/src"
import { scrollToAnchor } from "../../utils/scrollToAnchor"

interface StartPageProps extends PageBaseProps {
	mainContentArea: ContentAreaProperty
}

const StartPage: React.FC<StartPageProps> = (props) => {
	const { editMode } = React.useContext(EpiContext)

	const { hash } = useLocation()

	const id = decodeURI(hash.substring(1))

	const el = document?.getElementById(id)

	React.useEffect(() => {
		if (el) {
			//Scroll to anchorID position if it exists
			scrollToAnchor(el)
		}
	}, [el]) //UseEffect will run again when 'el' is ready

	return (
		<Flex display="block" w={1}>
			{shouldRender(editMode.inEditMode, props.mainContentArea?.value) && (
				<div data-epi-edit={"mainContentArea"}>
					<BlockResolver blocks={props.mainContentArea?.value} />
				</div>
			)}
		</Flex>
	)
}

export { StartPage }
